import React, { useContext } from 'react';
import nullthrows from 'nullthrows';

type LocationInText = [number] | [number, number];

interface AnnotationInText {
  location: LocationInText;
  annotationId: string;
}

interface AnnotationLocationMap {
  [n: number]: AnnotationLocationSpec;
}

interface AnnotationLocationSpec {
  selected?: boolean;
  annotations: string[];
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const createLocationMap = ({
  annotations,
  selectedLocation
}: {
  annotations: AnnotationInText[];
  selectedLocation?: LocationInText;
}): AnnotationLocationMap => {
  const map: AnnotationLocationMap = {};

  const getLocationBounds = (location: LocationInText): LocationInText => [
    location[0],
    location[1] === undefined ? location[0] : location[1]
  ];

  for (const annotation of annotations) {
    const bounds = getLocationBounds(annotation.location);
    for (let i = bounds[0]; i <= nullthrows(bounds[1]); i++) {
      map[i] = map[i] || {
        annotations: []
      };
      map[i].annotations.push(annotation.annotationId);
    }
  }

  if (selectedLocation) {
    const bounds = getLocationBounds(selectedLocation);
    for (let i = bounds[0]; i <= nullthrows(bounds[1]); i++) {
      map[i] = map[i] || {
        annotations: []
      };
      map[i].selected = true;
    }
  }

  return map;
};

type AnnotationLocationsType =
  | { loading: false; annotationMap: AnnotationLocationMap }
  | { loading: true; annotationMap?: AnnotationLocationMap };

const AnnotationLocationsContext = React.createContext<AnnotationLocationsType>({
  loading: true
});

export const AnnotationLocationsProvider: React.FC = ({ children }) => {
  const annotationMap: AnnotationLocationMap = {
    0: {
      annotations: ['Preamble']
    },
    45: {
      annotations: ['Article 1']
    },
    46: {
      annotations: ['Article 1']
    },
    47: {
      annotations: ['Article 1']
    },
    48: {
      annotations: ['Article 1']
    },
  };

  return (
    <AnnotationLocationsContext.Provider
      value={{
        loading: false,
        annotationMap
      }}>
      {children}
    </AnnotationLocationsContext.Provider>
  );
};

export const useAnnotationLocations = (): AnnotationLocationsType => {
  return useContext(AnnotationLocationsContext);
};
